// src/components/FeuilleConfirmation.jsx
//
// LA CONFIRMATION, DANS NOTRE GRAMMAIRE (décision Dimitri 2026-08-22).
//
// ⚠️ CE QUE ÇA REMPLACE : un `window.confirm` natif. Il fonctionnait, mais il
// est hors charte, il ignore Échap sur certains navigateurs, et sur téléphone
// c'est une boîte système qui n'a rien à voir avec l'écran qu'on regarde.
//
// LA FORME, la même que partout ailleurs :
//   · TÉLÉPHONE — une feuille qui MONTE DU BAS, sous un voile ;
//   · ORDINATEUR — une carte CENTRÉE, sous le même voile.
// Elle DIT ce que le geste implique, puis deux boutons : confirmer (la couleur
// de l'action) et renoncer. Échap et le clic sur le voile renoncent.
//
// PortailFeuille : la feuille est rendue dans <body> — sur téléphone, une
// couche du parent peut peindre par-dessus (anomalie mesurée le 22/08).

import PortailFeuille from './PortailFeuille'
import useEtroit from '../lib/useEtroit'
import useEchapPourFermer from '../lib/useEchapPourFermer'
import useVoileEcran from '../lib/useVoileEcran'
import { DS } from '../lib/ui'

export default function FeuilleConfirmation({
  titre, texte, libelleConfirmer = 'Confirmer', libelleRenoncer = 'Renoncer',
  ton = 'danger', occupe = false, onConfirmer, onRenoncer, testId = 'feuille-confirmation',
}) {
  const etroit = useEtroit()
  useVoileEcran()
  useEchapPourFermer(onRenoncer)

  const couleurs = ton === 'danger'
    ? { fond: '#b8412b', texte: '#fff' }
    : { fond: DS.marine, texte: '#fff' }

  const boutonBase = {
    minHeight: 44, borderRadius: 10, fontSize: 13, fontWeight: 700,
    fontFamily: DS.fontBody, cursor: occupe ? 'wait' : 'pointer', padding: '0 16px',
  }

  return (
    <PortailFeuille>
      <div data-testid={`${testId}-voile`} onClick={occupe ? undefined : onRenoncer}
        style={{ position: 'fixed', inset: 0, zIndex: 1200, background: 'rgba(35,50,64,.42)',
          display: 'flex', alignItems: etroit ? 'flex-end' : 'center', justifyContent: 'center' }}>
        <div data-testid={testId} role="dialog" aria-modal="true"
          onClick={(e) => e.stopPropagation()}
          style={{ background: '#fff', width: etroit ? '100%' : 'min(460px, calc(100% - 32px))',
            borderRadius: etroit ? '18px 18px 0 0' : 14,
            boxShadow: '0 -8px 30px rgba(35,50,64,.22)',
            padding: etroit ? '10px 16px calc(18px + env(safe-area-inset-bottom))' : '18px 20px',
            fontFamily: DS.fontBody }}>
          {etroit && (
            <div aria-hidden="true" style={{ width: 36, height: 4, borderRadius: 2,
              background: '#d5e3ee', margin: '0 auto 12px' }} />
          )}
          <div style={{ fontSize: 15, fontWeight: 700, color: DS.marineDark, marginBottom: 6 }}>
            {titre}
          </div>
          <div style={{ fontSize: 12.5, lineHeight: 1.5, color: DS.textSecondary, marginBottom: 16 }}>
            {texte}
          </div>
          <div style={{ display: 'flex', gap: 8, flexDirection: etroit ? 'column-reverse' : 'row',
            justifyContent: 'flex-end' }}>
            <button type="button" data-testid={`${testId}-renoncer`} onClick={onRenoncer}
              disabled={occupe} className="fbz-press"
              style={{ ...boutonBase, background: '#fff', color: DS.textSecondary,
                border: `1px solid ${DS.border}` }}>
              {libelleRenoncer}
            </button>
            <button type="button" data-testid={`${testId}-confirmer`} onClick={onConfirmer}
              disabled={occupe} className="fbz-press"
              style={{ ...boutonBase, background: couleurs.fond, color: couleurs.texte, border: 'none' }}>
              {libelleConfirmer}
            </button>
          </div>
        </div>
      </div>
    </PortailFeuille>
  )
}
